// removed by extract-text-webpack-plugin
module.exports = {"configurationContainer":"_1MMZjjgv3jKa9Y0yPNKgX0","rowContainer":"_3vRF65fGPj3AN7w82Lx1vI","title":"P9Ylr4DcoorXfWjSviZ_E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceConfig/DeviceConfigItem.less
// module id = 1611
// module chunks = 0